__turbopack_context__.v({
  "buttonsContainer": "styles-module__iYyUfa__buttonsContainer",
  "message": "styles-module__iYyUfa__message",
  "modalContent": "styles-module__iYyUfa__modalContent",
  "objectName": "styles-module__iYyUfa__objectName",
});
